"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var responsive_1 = require("@dynamynd/responsive");

var react_1 = __importDefault(require("react"));

var redux_1 = require("redux");

var styled_components_1 = require("styled-components");

var app_1 = require("../../../config/app");

var backgrounds_styled_1 = require("../styled/backgrounds.styled");

var BackgroundWithShapes =
/** @class */
function (_super) {
  __extends(BackgroundWithShapes, _super);

  function BackgroundWithShapes() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  BackgroundWithShapes.prototype.render = function () {
    var _a = this.props,
        children = _a.children,
        height = _a.height,
        width = _a.width,
        activeBreakpoint = _a.activeBreakpoint,
        theme = _a.theme,
        _b = _a.shapes,
        topLeft = _b.topLeft,
        topRight = _b.topRight,
        bottomLeft = _b.bottomLeft,
        bottomRight = _b.bottomRight,
        shouldExpand = _a.shouldExpand;
    return react_1.default.createElement(backgrounds_styled_1.BackgroundContainer, __assign({}, this.props, {
      height: height,
      activeBreakpoint: activeBreakpoint,
      backgroundColor: theme.backgroundColor.homeAndSurveyBackground,
      shouldExpand: shouldExpand
    }), topLeft && react_1.default.createElement(backgrounds_styled_1.TopLeftContainer, {
      width: width,
      source: {
        uri: app_1.appConfig.shapes.landingTopLeft
      }
    }), topRight && react_1.default.createElement(backgrounds_styled_1.TopRightContainer, {
      width: width,
      source: {
        uri: app_1.appConfig.shapes.landingTopRight
      }
    }), bottomLeft && react_1.default.createElement(backgrounds_styled_1.BottomLeftContainer, {
      width: width,
      source: {
        uri: app_1.appConfig.shapes.landingBottomLeft
      }
    }), bottomRight && react_1.default.createElement(backgrounds_styled_1.BottomRightContainer, {
      width: width,
      height: height,
      source: {
        uri: app_1.appConfig.shapes.landingBottomRight
      }
    }), children);
  };

  return BackgroundWithShapes;
}(react_1.default.Component);

var hoc = redux_1.compose(styled_components_1.withTheme, responsive_1.withResponsiveMeta);
exports.default = hoc(BackgroundWithShapes);